import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=3a956066&scoped=true&"
import script from "./Publication.vue?vue&type=script&lang=js&"
export * from "./Publication.vue?vue&type=script&lang=js&"
import style0 from "./Publication.vue?vue&type=style&index=0&id=3a956066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a956066",
  null
  
)

export default component.exports